import { supabase, run } from './db';

/**
 * O que o resumo de gestão precisa buscar e o quadro não tem em memória.
 *
 * Serviços e clientes o sistema já carrega; faturas, recebimentos, estoque e
 * a trilha da equipe não. Sem `cached`, como o resto do financeiro: um resumo
 * mandado ao dono do laboratório com saldo velho é pior que resumo nenhum.
 *
 * `comDinheiro` falso nem pergunta pelo financeiro — quem não pode abrir a
 * porta do financeiro na tela também não a abre pela imagem.
 */
export const buscarGestao = async ({ laboratoryId, de, ate, comDinheiro }) => {
  const doLab = (tabela, colunas) => supabase.from(tabela).select(colunas).eq('laboratory_id', laboratoryId);
  const nada = Promise.resolve([]);

  const [faturas, recebimentos, emAberto, congelados, saidas, semen, trilha] = await Promise.all([
    comDinheiro
      ? run(doLab('invoices_com_total', 'id, client_id, numero_exibicao, tipo, emitida_em, cancelada_em, valor_total')
        .gte('emitida_em', de).lte('emitida_em', ate).is('cancelada_em', null))
      : nada,
    comDinheiro
      ? run(doLab('recebimentos', 'id, recebido_em, valor').gte('recebido_em', de).lte('recebido_em', ate))
      : nada,
    comDinheiro
      ? run(doLab('vw_parcelas_em_aberto', 'id, client_id, numero_exibicao, vencimento, saldo'))
      : nada,
    run(doLab('embryos', 'id, freeze_date').gte('freeze_date', de).lte('freeze_date', ate)),
    run(doLab('embryos', 'id, saida_em, saida_motivo').gte('saida_em', de).lte('saida_em', ate)),
    run(doLab('semen_movimentos', 'id, tipo, doses, data').gte('data', de).lte('data', ate)),
    // Só o nome e o que foi feito: o resumo conta, não investiga.
    run(doLab('audit_log', 'actor_name, table_name, action, at')
      .gte('at', `${de}T00:00:00-03:00`).lte('at', `${ate}T23:59:59.999-03:00`)),
  ]);

  return { faturas, recebimentos, emAberto, congelados, saidas, semen, trilha };
};
